






























































import { Toast } from '@ks/sharp-ui';
import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
// eslint-disable-next-line
import type { CommodityTradeInfo } from '@/views/Detail/model';
import yoda from '@/yoda';

@Component
export default class ExpireDialog extends Vue {
    @Prop(Object)
    commodityTradeInfo!: CommodityTradeInfo;
    @Prop(Boolean)
    useKscoinPay;
    name: string = 'expire-dialog';
    intervalList: string[] = [];
    selectIndex: number = -1;
    submitting: boolean = false;
    timeStamp: number = new Date().getTime();
    expireTime: number = -1;

    @Watch('commodityTradeInfo', { deep: true, immediate: true })
    onCommodityTradeInfo(info) {
        let { skuList = [] } = info || {};
        this.intervalList =
            (skuList &&
                skuList.map(({ specs = {} as any }) => {
                    // 目前specs只会返回一个所以只取第一个，具体原因参考电商商品，返回对象
                    if (+specs[1].value === -1) {
                        return '永久有效';
                    }
                    return `${Math.floor(+specs[1].value / (1000 * 60 * 60 * 24))}天`;
                })) ||
            [];
    }
    get selectInfo() {
        return (this.selectIndex !== -1 && this.commodityTradeInfo.skuList[this.selectIndex]) || null;
    }
    get formatInterval() {
        return dayjs(this.expireTime).format('YYYY/MM/DD HH:mm:ss');
    }
    get priceInterval() {
        const inset = -1;
        const {
            minPrice = inset,
            maxPrice = inset,
            minKscoinPrice = inset,
            maxKscoinPrice = inset,
        } = this.commodityTradeInfo;
        if (this.selectIndex === -1) {
            if (this.commodityTradeInfo.skuList?.length >= 2) {
                return this.useKscoinPay
                    ? `${minKscoinPrice}~${maxKscoinPrice}`
                    : `${minPrice / 100}~${maxPrice / 100}`;
            }
            return this.useKscoinPay ? minKscoinPrice : minPrice / 100;
        }
        const { unitPrice = inset, kscoinPrice = inset } = this.selectInfo || {};
        return this.useKscoinPay ? kscoinPrice : unitPrice / 100;
    }
    get isShowIntervalMsg() {
        return this.selectInfo && +this.selectInfo.specs[1].value !== -1;
    }
    mounted() {
        // Log: 时效性收银台
        if (yoda.isInYoda) {
            window.ksLog?.sendCountTag('Lightks_ExpireDialog');
        }
    }
    submitInterval() {
        if (this.selectIndex === -1) {
            return;
        }
        if (new Date().getTime() - this.timeStamp >= 5 * 60 * 1000) {
            this.waitLongTime();
            return;
        }
        this.$emit('to-submit', {
            expireTime: this.expireTime,
            ...this.selectInfo,
        });
    }
    waitLongTime() {
        Toast.info('页面停留过久，请重新选择');
        this.selectIndex = -1;
        this.timeStamp = new Date().getTime();
    }
    selectInterval(index) {
        this.selectIndex = index;
        const interval = (this.selectInfo && +this.selectInfo.specs[1].value) || 0;
        this.expireTime = interval === -1 ? interval : this.timeStamp + interval;
    }
    toClose() {
        if (this.submitting) {
            Toast.info('正在提交中，请勿关闭');
        } else {
            this.$emit('close');
        }
    }
}
